module.exports = __webpack_public_path__ + "img/rp.e4f7558e.png";